import FetchQrCode from 'utils/fetch/FetchQrCode'

const Qrcode_MOD = {
	
	scan: ( qrcode, onSuccess, onError ) => {
		FetchQrCode.fetch( qrcode, {
			callbackSuccess: ( { qrcode } ) => {
				Qrcode_MOD.receivedQrCode( qrcode, onSuccess, onError )
			},
			callbackError: onError
		});
	},
	
	scanOld: ( code, onSuccess, onError ) => {
		FetchQrCode.fetchOld( code, {
			callbackSuccess: ( { qrcode } ) => {
				Qrcode_MOD.receivedQrCode( qrcode, onSuccess, onError )
			},
			callbackError: onError
		});
	},
	
	receivedQrCode: ( qrcode, onSuccess, onError ) => {
		if( qrcode.guid !== null ){
			onSuccess( qrcode );
			return;
		}
		onError();
	},
};

export default Qrcode_MOD
